import { useState, useEffect } from "react"
import { onPaste } from "~/utils"
import ThreeTasks from "./components/ThreeTasks"
import GenericTasks from "./components/GenericTasks"
import DayNotes from "./components/DayNotes"
import StickyNotes from "./components/StickyNotes"
import Diet from "./components/Diet"
import Chains from "./components/Chains.svelte"
import Calendar from "react-calendar"
import strftime from "strftime"
import "react-calendar/dist/Calendar.css"

function App({ initialData }) {
  useEffect(() => {
    window.addEventListener("paste", onPaste)

    const root = document.querySelector("#chains")

    if (root === null) return

    new Chains({
      target: root,
      props: { chains: initialData.chains }
    })

    return () => {
      window.removeEventListener("paste", onPaste)
    }
  })

  return (
    <div>
      <div className="space-y-8 lg:flex lg:space-x-8 lg:space-y-0">
        <div className="lg:w-7/12">
          <CurrentDate
            initialDate={initialData.date}
            previousDay={initialData.previous_day}
            nextDay={initialData.next_day}
          />

          <div className="items-stretch md:flex">
            <div className="md:w-5/8">
              <ThreeTasks
                dayId={initialData.id}
                initialTasks={initialData.three_tasks}
                dailies={initialData.dailies}
              />

              <StickyNotes notes={initialData.sticky_notes} />
            </div>

            <div className="flex flex-col gap-2 pt-2 md:w-3/8">
              <div id="chains" />
              <Diet dayId={initialData.id} initialData={initialData.diet} />
            </div>
          </div>

          <DayNotes dayId={initialData.id} notes={initialData.day_notes} />
        </div>

        <div className="lg:w-5/12">
          <GenericTasks
            title={strftime("%A", new Date(Date.parse(initialData.date)))}
            dayDate={initialData.date}
            dayId={initialData.id}
            tasks={initialData.generic_tasks}
          />
        </div>
      </div>
    </div>
  )
}

const CurrentDate = ({ initialDate, previousDay, nextDay }) => {
  const date = new Date(Date.parse(initialDate))
  const [opened, setOpened] = useState(false)

  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)

  const changeDate = (newDate) => {
    const parser = new URL(window.location)
    parser.searchParams.set("date", strftime("%Y-%m-%d", newDate))
    window.location = parser.href
  }

  const goToDate = (targetDate) => {
    if (!targetDate) return

    const parser = new URL(window.location)
    parser.searchParams.set("date", targetDate)
    window.location = parser.href
  }

  return (
    <div className="flex items-center gap-3 border-b border-dashed border-fg-muted pb-4">
      {previousDay && (
        <button
          type="button"
          className="text-lg text-fg-muted hover:text-fg"
          aria-label="Previous day"
          onClick={() => goToDate(previousDay)}
        >
          ←
        </button>
      )}
      <div className="relative">
        <span
          className="mb-8 cursor-pointer pb-2 font-heading text-4xl text-fg"
          onClick={() => {
            setOpened((prev) => !prev)
          }}
        >
          {strftime("%b %d", date)}
        </span>
        <div className={`z-10 mt-2 bg-white ${opened ? "absolute" : "hidden"}`}>
          <Calendar
            onChange={changeDate}
            value={date}
            className="rounded-md px-4 py-2"
            maxDate={tomorrow}
          />
        </div>
      </div>
      {nextDay && (
        <button
          type="button"
          className="text-lg text-fg-muted hover:text-fg"
          aria-label="Next day"
          onClick={() => goToDate(nextDay)}
        >
          →
        </button>
      )}
    </div>
  )
}

export default App
